/* @flow */
import * as React from 'react'
import Login from '@/pages/login/Login'

const LoginLayout = props => {
  return <Login />
}

export default LoginLayout
